import BaseComponent from "../../components/BaseComponent";
import {
    Button,
    ButtonGroup,
    Div,
    FormItem,
    FormLayout,
    Input,
    NativeSelect,
    Panel,
    PanelHeader,
    PanelHeaderButton,
    SimpleCell,
    SplitCol,
    SplitLayout,
    Switch,
    Textarea
} from "@vkontakte/vkui";
import {Icon24BrowserBack} from "@vkontakte/icons";
import React from "react";
import IMask from "imask";
import {
    AdaptivityContext,
    getStaffPositions,
    getTtStaffPositions,
    SELLER_QUALIFICATIONS
} from "../../assets/constants";
import SalePointSelectObject from "../../salePointsMonitoring/salePointSelectObject";
import SalePointSellersApi from "../../api/references/salePointSellers";

class StaffForm extends BaseComponent {

    state = {
        error_last_name: '',
        error_first_name: '',
        error_sale_point: '',
        loading: false,
    }

    cmdBack = () => {
        window.postMessage({
            type: 'setCurrentStaff',
            value: null
        })
        if (this.props.hideForm) {
            this.props.hideForm()
        }
    }

    bindPhoneMask = (el) => {
        if (!el) {
            if (this.phoneMask) {
                try { this.phoneMask.destroy() } catch (e) { /* ignore */ }
                this.phoneMask = null
            }
            return
        }
        if (this.phoneMask) {
            return
        }
        this.phoneMask = IMask(el, {
            mask: '+{7}(000)000-00-00',
        })
        if (this.props.item && this.props.item.phone) {
            this.phoneMask.value = String(this.props.item.phone)
        }
        this.phoneMask.on('accept', () => {
            this.props.change({currentTarget: {value: this.phoneMask.value}}, 'phone')
        })
    }

    componentWillUnmount() {
        if (this.phoneMask) {
            try { this.phoneMask.destroy() } catch (e) { /* ignore */ }
            this.phoneMask = null
        }
        if (super.componentWillUnmount) {
            super.componentWillUnmount()
        }
    }

    toDateInput = (ts) => {
        if (!ts) {
            return ''
        }
        if (typeof ts === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(ts)) {
            return ts
        }
        const numeric = typeof ts === 'string' ? Number(ts) : ts
        if (!numeric || isNaN(numeric)) {
            return ''
        }
        const d = new Date(numeric * 1000)
        if (isNaN(d.getTime())) {
            return ''
        }
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${d.getFullYear()}-${m}-${day}`
    }

    formatModeratedAt = (ts) => {
        if (!ts) {
            return ''
        }
        const d = new Date(ts * 1000)
        if (isNaN(d.getTime())) {
            return ''
        }
        const pad = (n) => String(n).padStart(2, '0')
        return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    }

    setSalePoint = (sale_point) => {
        if (!sale_point || !sale_point.uid) {
            return
        }
        this.props.change({
            sale_point_id: sale_point.uid,
            sale_point,
        })
    }

    save = () => {
        const {item} = this.props
        const errors = {
            error_last_name: '',
            error_first_name: '',
            error_sale_point: '',
        }
        let hasError = false
        if (!item.last_name || !String(item.last_name).trim()) {
            errors.error_last_name = 'Необходимо заполнить Фамилия'
            hasError = true
        }
        if (!item.first_name || !String(item.first_name).trim()) {
            errors.error_first_name = 'Необходимо заполнить Имя'
            hasError = true
        }
        if (!item.sale_point_id) {
            errors.error_sale_point = 'Необходимо указать торговую точку'
            hasError = true
        }
        this.setState(errors)
        if (hasError) {
            return
        }

        this.setState({loading: true})
        const payload = {
            id: item.id > 0 ? item.id : 0,
            guid: item.guid || '',
            last_name: item.last_name,
            first_name: item.first_name,
            middle_name: item.middle_name || '',
            birth_date: item.birth_date || null,
            phone: item.phone || '',
            sale_point_id: item.sale_point_id,
            position_id: item.position_id || 0,
            is_owner: item.is_owner ? 1 : 0,
            is_lpr: item.is_lpr ? 1 : 0,
            qualification: item.qualification || 0,
            comment: item.comment || '',
        }
        SalePointSellersApi.save(payload).then(result => {
            this.setState({loading: false})
            const {data} = result
            if (data && data.id) {
                window.postMessage({type: 'setCurrentStaff', value: data})
                window.postMessage({type: 'success', text: 'Данные сохранены', timeout: 1500, hideSpinner: true})
            }
        }).catch(() => {
            this.setState({loading: false})
        })
    }

    salePointMetaLine = () => {
        const sp = this.props.item && this.props.item.sale_point
        if (!sp || !(sp.uid || sp.id)) {
            return null
        }
        const parts = [
            sp.klient && sp.klient.title,
            sp.title,
            sp.full_address,
        ].filter(Boolean)
        if (!parts.length) {
            return null
        }
        return <div style={{
            fontSize: 12,
            color: 'var(--vkui--color_text_secondary)',
            padding: '0 16px 8px',
            marginTop: -8,
            lineHeight: 1.35,
        }}>
            {parts.join(' · ')}
        </div>
    }

    fioTitle = () => {
        const {item} = this.props
        const fio = [item.last_name, item.first_name, item.middle_name].filter(Boolean).join(' ')
        return item && item.id > 0 ? `Сотрудник ТТ ${fio}` : 'Новый сотрудник ТТ'
    }

    render() {
        const {item} = this.props
        if (!item) {
            return null
        }
        const positions = getTtStaffPositions()
        if (item.position_id && !positions[item.position_id]) {
            const all = getStaffPositions()
            if (all[item.position_id]) {
                positions[item.position_id] = all[item.position_id]
            }
        }
        const positionKeys = Object.keys(positions)
        const qualKeys = Object.keys(SELLER_QUALIFICATIONS)

        return <SplitLayout>
            <SplitCol>
                <PanelHeader style={{whiteSpace: "pre-line"}} before={
                    <PanelHeaderButton onClick={() => this.cmdBack()}
                                       key="cmd_back_staff_form"><Icon24BrowserBack/></PanelHeaderButton>}>
                    {this.fioTitle()}
                </PanelHeader>
                <Panel>
                    <Div>
                        <FormLayout>
                            <FormItem top="Фамилия" status={this.state.error_last_name ? 'error' : ''}
                                      bottom={this.state.error_last_name}>
                                <Input type="text" value={item.last_name || ''}
                                       onChange={(e) => this.props.change(e, 'last_name')}/>
                            </FormItem>
                            <FormItem top="Имя" status={this.state.error_first_name ? 'error' : ''}
                                      bottom={this.state.error_first_name}>
                                <Input type="text" value={item.first_name || ''}
                                       onChange={(e) => this.props.change(e, 'first_name')}/>
                            </FormItem>
                            <FormItem top="Отчество">
                                <Input type="text" value={item.middle_name || ''}
                                       onChange={(e) => this.props.change(e, 'middle_name')}/>
                            </FormItem>
                            <FormItem top="Дата рождения">
                                <Input type="date" value={this.toDateInput(item.birth_date)}
                                       onChange={(e) => this.props.change(e, 'birth_date')}/>
                            </FormItem>
                            <FormItem top="Тел">
                                <Input type="tel"
                                       getRef={this.bindPhoneMask}
                                       defaultValue={item.phone || ''}
                                       placeholder="+7(___)___-__-__"/>
                            </FormItem>
                            <SalePointSelectObject
                                current_user={this.props.current_user}
                                title="Торговая точка"
                                app="salePoints"
                                act="getList"
                                className={'selectObjectDropdownStyle'}
                                style={{minHeight: '33px'}}
                                error={this.state.error_sale_point}
                                modal_title="Торговые точки"
                                unselect_title="Выберите торговую точку"
                                base_url={this.props.base_url || this.state.base_url}
                                selectObject={this.setSalePoint}
                                default={item.sale_point || undefined}
                                mode="outline"
                                size="s"
                            />
                            {this.salePointMetaLine()}
                            <FormItem top="Должность">
                                <NativeSelect
                                    value={item.position_id || 0}
                                    onChange={(e) => this.props.change(e, 'position_id')}
                                >
                                    {positionKeys.map((key) => (
                                        <option key={`pos-${key}`} value={key}>{positions[key]}</option>
                                    ))}
                                </NativeSelect>
                            </FormItem>
                            <FormItem>
                                <SimpleCell Component="label" multiline
                                            after={<Switch checked={!!item.is_owner}
                                                           onChange={(e) => this.props.change(e, 'is_owner')}/>}>
                                    Собственник
                                </SimpleCell>
                            </FormItem>
                            <FormItem>
                                <SimpleCell Component="label" multiline
                                            after={<Switch checked={!!item.is_lpr}
                                                           onChange={(e) => this.props.change(e, 'is_lpr')}/>}>
                                    ЛПР
                                </SimpleCell>
                            </FormItem>
                            <FormItem top="Квалификация продавца">
                                <NativeSelect
                                    value={item.qualification || 0}
                                    onChange={(e) => this.props.change(e, 'qualification')}
                                >
                                    {qualKeys.map((key) => (
                                        <option key={`qual-${key}`} value={key}>{SELLER_QUALIFICATIONS[key]}</option>
                                    ))}
                                </NativeSelect>
                            </FormItem>
                            <FormItem top="Комментарий">
                                <Textarea value={item.comment || ''} rows={4}
                                          onChange={(e) => this.props.change(e, 'comment')}/>
                            </FormItem>
                            <FormItem top="Дата и время модерации">
                                <Input type="text" disabled value={this.formatModeratedAt(item.moderated_at)}/>
                            </FormItem>
                            <FormItem top="Логин Складро">
                                <Input type="text" disabled value={item.moderated_by_login || ''}/>
                            </FormItem>
                        </FormLayout>
                    </Div>
                    <Div className={AdaptivityContext.isMobile ? "action-board" : ''}>
                        <ButtonGroup mode="horizontal" stretched style={{justifyContent: 'end'}}>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    style={{maxWidth: '50%'}}
                                    onClick={() => this.cmdBack()}>Отмена</Button>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    style={{maxWidth: '50%'}}
                                    loading={this.state.loading}
                                    onClick={() => this.save()}>Сохранить</Button>
                        </ButtonGroup>
                    </Div>
                </Panel>
            </SplitCol>
        </SplitLayout>
    }
}

export default StaffForm
